import StandEditForm from "./stand-edit-form";
import StandFileEditForm from "./stand-file-edit-form";
import StandNoteEditForm from "./stand-note-edit-form";
import StandFiltersForm from "./stand-filters-form";
import StandAdd3dModelForm from "./stand-add-3d-model-form/stand-add-3d-model-form";

const StandForms = {
  Edit: StandEditForm,
  EditFile: StandFileEditForm,
  EditNote: StandNoteEditForm,
  Filter: StandFiltersForm,
  StandAdd3dModel: StandAdd3dModelForm,
};

export default StandForms;
